// src/components/SocialFooter.js
import './SocialFooter.css'

const SOCIALS = [
  { label: 'Instagram', url: process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/realskybri' },
  { label: 'TikTok',    url: process.env.REACT_APP_TIKTOK    || 'https://www.tiktok.com/@skybribaby' },
  { label: 'X',         url: process.env.REACT_APP_TWITTER   || 'https://x.com/skybri_' },
]

export default function SocialFooter() {
  return (
    <footer className="sfooter">
      <div className="sfooter__divider" />
      <div className="sfooter__inner">
        <div className="sfooter__logo">
          <span style={{ color: 'var(--gold)' }}>Sky</span> Bri
        </div>
        <div className="sfooter__tagline">Skylar Brianna Harrison · Private Members Platform</div>
        <div className="sfooter__links">
          {SOCIALS.map(s => (
            <a key={s.label} href={s.url} target="_blank" rel="noreferrer" className="sfooter__link">
              {s.label}
            </a>
          ))}
        </div>
        <div className="sfooter__copy">
          © {new Date().getFullYear()} Sky Bri · All rights reserved · Private & Confidential
        </div>
      </div>
    </footer>
  )
}
